// MenuLogo.tsx
import React from "react";

interface MenuLogoProps {
  className?: string;
}

const MenuLogo: React.FC<MenuLogoProps> = ({ className }) => (
  <div className={className}>
    <svg viewBox="0 0 168 40" className="h-6 sm:h-10">
      <path
        id="Swirl border"
        className="fill-meteoyellow-500"
        d="M 0.11,35.70
      C 0.11,38.06 2.04,40.00 4.41,40.00
        4.41,40.00 35.11,40.00 35.11,40.00
        37.47,40.00 39.41,38.06 39.41,35.70
        39.41,35.70 39.41,4.30 39.41,4.30
        39.41,1.94 37.47,0.00 35.11,0.00
        35.11,0.00 4.35,0.00 4.35,0.00
        1.99,0.00 0.05,1.94 0.05,4.30
        0.05,4.30 0.11,35.70 0.11,35.70"
      />
      <path
        id="Poop swirl"
        className="fill-current stroke-current stroke-[0.5]"
        d="M 4.89,2.51
           C 5.23,2.51 5.49,2.94 5.71,3.17
             6.21,3.67 6.74,4.16 7.43,4.36
             7.57,4.40 7.88,4.46 8.02,4.46
             8.02,4.46 10.33,4.06 10.33,4.06
             11.21,4.05 11.90,4.14 12.64,4.67
             12.64,4.67 13.58,5.50 13.58,5.50
             13.84,5.61 14.40,5.47 14.70,5.50
             14.70,5.50 15.83,5.63 15.83,5.63
             16.35,5.74 16.42,5.83 17.01,5.83
             18.30,5.83 19.14,5.62 20.44,6.04
             20.96,6.20 21.21,6.28 21.68,6.58
             21.92,6.73 22.43,7.14 22.63,7.21
             22.83,7.28 23.50,7.25 23.75,7.25
             24.57,7.26 26.08,7.51 26.83,7.81
             26.83,7.81 28.48,8.61 28.48,8.61
             28.48,8.61 29.49,8.77 29.49,8.77
             30.00,8.88 31.27,9.25 31.73,9.46
             33.60,10.29 35.03,11.81 35.67,13.76
             35.95,14.62 36.04,15.63 36.05,16.53
             36.06,17.04 36.19,17.15 36.33,17.60
             36.49,18.16 36.64,18.85 36.64,19.43
             36.65,20.08 36.66,20.75 36.56,21.39
             36.45,22.09 36.23,22.78 36.00,23.45
             35.24,25.65 34.02,27.55 32.52,29.31
             32.52,29.31 31.43,30.54 31.43,30.54
             28.51,33.46 24.60,35.95 20.62,37.10
             19.53,37.41 18.32,37.71 17.19,37.82
             17.19,37.82 16.71,37.82 16.71,37.82
             16.71,37.82 16.01,37.89 16.01,37.89
             16.01,37.89 15.00,37.89 15.00,37.89
             15.00,37.89 13.99,37.78 13.99,37.78
             12.30,37.54 10.91,37.07 9.56,35.96
             8.93,35.44 8.78,35.09 8.31,34.57
             8.31,34.57 7.02,33.60 7.02,33.60
             6.43,33.11 5.59,32.07 5.26,31.38
             4.52,29.82 4.53,28.96 4.53,27.30
             4.53,27.30 4.71,25.70 4.71,25.70
             4.74,25.32 4.61,24.95 4.55,24.58
             4.46,23.98 4.47,23.63 4.47,23.04
             4.47,22.01 4.92,20.64 5.18,19.61
             5.18,19.61 5.39,18.79 5.39,18.79
             5.39,18.79 5.18,17.19 5.18,17.19
             5.16,16.45 5.44,15.39 5.45,15.17
             5.45,14.99 5.34,14.72 5.30,14.53
             5.22,14.21 5.18,13.79 5.18,13.46
             5.19,13.13 5.31,12.48 5.43,12.16
             5.43,12.16 5.69,11.39 5.69,11.39
             5.71,11.20 5.62,10.99 5.56,10.80
             5.56,10.80 5.34,9.79 5.34,9.79
             5.34,9.79 4.64,6.48 4.64,6.48
             4.54,6.07 4.22,4.70 4.24,4.35
             4.27,3.87 4.45,2.76 4.89,2.51 Z
           M 5.08,3.99
           C 4.86,4.14 4.88,4.45 4.89,4.71
             4.90,5.25 5.11,5.88 5.20,6.42
             5.20,6.42 5.51,7.90 5.51,7.90
             5.51,7.90 5.81,9.32 5.81,9.32
             5.95,10.12 5.92,10.41 6.45,11.10
             6.80,11.54 7.11,11.69 7.67,11.79
             7.84,11.82 8.15,11.87 8.32,11.85
             9.87,11.74 11.38,10.88 12.40,9.74
             12.63,9.47 12.86,9.22 13.03,8.91
             13.36,8.31 13.70,7.45 13.44,6.78
             13.28,6.37 12.87,5.97 12.40,6.02
             11.95,6.08 11.88,6.36 10.98,6.37
             10.98,6.37 10.39,6.37 10.39,6.37
             9.62,6.36 8.42,6.02 7.73,5.70
             7.13,5.42 6.52,5.06 6.01,4.63
             5.76,4.42 5.42,4.00 5.08,3.99 Z
           M 6.72,16.48
           C 6.91,17.40 8.28,17.72 9.09,17.72
             9.09,17.72 9.92,17.72 9.92,17.72
             11.42,17.72 13.72,16.73 15.00,15.94
             16.79,14.84 18.59,13.22 19.64,11.39
             20.05,10.67 20.49,9.75 20.50,8.91
             20.50,8.91 20.50,8.43 20.50,8.43
             20.49,7.35 19.79,6.56 18.79,6.23
             18.53,6.15 17.68,5.88 17.49,6.17
             17.37,6.35 17.75,6.75 17.85,6.89
             18.28,7.51 18.51,8.10 18.49,8.85
             18.46,10.23 17.58,11.83 16.72,12.87
             15.43,14.42 13.81,15.58 11.93,16.30
             11.93,16.30 11.21,16.57 11.21,16.57
             10.43,16.79 9.61,16.89 8.79,16.89
             7.77,16.89 7.40,16.58 6.72,16.48 Z
           M 14.07,6.11
           C 13.86,6.30 14.07,6.60 14.13,6.84
             14.18,7.04 14.18,7.22 14.17,7.43
             14.16,8.31 13.29,9.65 12.75,10.33
             11.74,11.56 10.67,12.08 9.15,12.41
             8.82,12.48 8.53,12.56 8.20,12.57
             7.77,12.58 7.29,12.50 6.90,12.32
             6.75,12.26 6.44,12.05 6.28,12.16
             6.06,12.32 6.32,12.99 6.44,13.16
             6.91,13.87 7.79,13.94 8.56,13.93
             9.69,13.93 11.54,13.14 12.46,12.49
             12.97,12.13 13.48,11.76 13.94,11.33
             14.87,10.44 15.77,9.10 15.87,7.78
             15.94,6.85 15.02,5.88 14.07,6.11 Z
           M 5.71,13.52
           C 5.44,14.63 6.26,15.74 7.25,16.16
             7.95,16.45 8.42,16.42 9.15,16.42
             12.40,16.41 16.01,13.89 17.44,11.03
             17.88,10.16 18.16,8.40 17.73,7.49
             17.49,6.97 17.09,6.46 16.48,6.42
             16.48,6.42 16.70,7.61 16.70,7.61
             16.70,7.77 16.60,8.21 16.55,8.38
             16.33,9.17 15.93,9.74 15.44,10.39
             14.35,11.83 12.52,13.15 10.86,13.87
             10.13,14.18 9.18,14.52 8.38,14.53
             7.75,14.53 7.10,14.52 6.55,14.17
             6.20,13.96 6.12,13.71 5.71,13.52 Z
           M 5.83,16.60
           C 5.67,17.05 5.73,17.54 5.83,18.02
             6.21,20.05 8.11,21.00 10.03,21.08
             10.03,21.08 11.21,20.97 11.21,20.97
             12.74,20.95 14.11,20.48 15.47,19.83
             18.27,18.52 21.05,16.20 22.35,13.34
             22.63,12.74 22.85,12.06 22.93,11.39
             22.93,11.39 22.93,10.92 22.93,10.92
             23.04,9.80 23.15,9.10 22.50,8.08
             22.10,7.47 21.38,6.82 20.62,6.78
             20.74,7.42 21.14,7.51 21.15,8.38
             21.15,8.38 21.15,8.73 21.15,8.73
             21.15,10.09 20.24,11.55 19.43,12.57
             18.77,13.39 17.78,14.43 16.95,15.06
             16.95,15.06 15.89,15.81 15.89,15.81
             15.41,16.15 14.93,16.48 14.41,16.76
             14.41,16.76 13.23,17.32 13.23,17.32
             11.97,17.93 10.48,18.31 9.09,18.31
             8.43,18.31 7.51,18.14 6.96,17.77
             6.45,17.43 6.27,17.08 5.95,16.60
             5.95,16.60 5.83,16.60 5.83,16.60 Z
           M 23.16,7.96
           C 23.28,8.72 23.68,9.05 23.70,10.21
             23.72,12.13 22.73,14.11 21.58,15.59
             21.58,15.59 21.08,16.24 21.08,16.24
             21.08,16.24 20.33,17.01 20.33,17.01
             18.56,18.78 16.54,20.10 14.17,20.93
             13.12,21.30 11.99,21.61 10.86,21.62
             9.61,21.64 8.35,21.53 7.25,20.85
             7.00,20.69 6.58,20.35 6.37,20.14
             6.25,20.02 6.03,19.73 5.89,19.68
             5.53,19.54 5.54,20.30 5.54,20.50
             5.54,21.20 5.51,21.95 5.69,22.63
             5.81,23.07 6.15,23.41 6.48,23.70
             7.23,24.34 8.19,24.61 9.15,24.71
             9.39,24.73 9.47,24.77 9.74,24.76
             9.74,24.76 10.39,24.70 10.39,24.70
             11.63,24.68 12.77,24.41 13.94,24.02
             16.27,23.24 18.34,22.06 20.26,20.53
             21.51,19.53 22.70,18.48 23.66,17.19
             24.71,15.77 26.06,13.63 26.06,11.80
             26.06,11.80 26.06,11.21 26.06,11.21
             26.05,9.95 25.28,8.70 24.11,8.20
             23.79,8.06 23.51,7.91 23.16,7.96 Z
           M 5.18,23.04
           C 5.18,23.04 5.13,23.45 5.13,23.45
             5.12,23.71 5.15,23.81 5.18,24.05
             5.18,24.05 5.28,24.88 5.28,24.88
             5.43,25.60 5.92,26.64 6.44,27.18
             7.28,28.05 7.82,28.18 8.91,28.54
             8.91,28.54 10.33,28.97 10.33,28.97
             10.33,28.97 10.98,29.05 10.98,29.05
             10.98,29.05 11.98,29.19 11.98,29.19
             11.98,29.19 13.05,29.07 13.05,29.07
             15.07,28.74 16.27,28.31 18.13,27.50
             19.49,26.92 20.80,26.28 22.04,25.46
             22.04,25.46 22.75,24.95 22.75,24.95
             22.75,24.95 23.22,24.65 23.22,24.65
             23.22,24.65 23.75,24.22 23.75,24.22
             23.75,24.22 24.88,23.32 24.88,23.32
             24.88,23.32 25.53,22.69 25.53,22.69
             26.97,21.35 28.53,19.62 29.20,17.72
             29.20,17.72 29.85,16.18 29.85,16.18
             29.85,16.18 30.20,14.65 30.20,14.65
             30.20,14.65 30.20,14.11 30.20,14.11
             30.20,14.11 30.25,13.70 30.25,13.70
             30.25,13.70 30.21,13.23 30.21,13.23
             30.08,11.48 29.27,9.90 27.72,9.01
             27.14,8.68 26.09,8.13 25.41,8.32
             25.64,8.75 26.01,8.98 26.29,9.38
             26.80,10.10 26.90,10.77 26.89,11.63
             26.88,11.95 26.82,12.26 26.76,12.57
             26.35,14.60 25.12,16.49 23.76,18.02
             23.76,18.02 22.69,19.20 22.69,19.20
             21.66,20.20 20.34,21.25 19.14,22.05
             19.14,22.05 18.55,22.41 18.55,22.41
             18.55,22.41 16.66,23.56 16.66,23.56
             16.66,23.56 15.12,24.25 15.12,24.25
             13.44,24.97 11.40,25.55 9.56,25.53
             8.38,25.51 7.13,25.21 6.25,24.39
             6.03,24.19 5.80,23.89 5.65,23.63
             5.49,23.35 5.52,23.15 5.18,23.04 Z
           M 5.42,27.18
           C 5.15,27.93 5.32,29.32 5.58,30.08
             5.77,30.66 5.99,31.24 6.35,31.73
             6.60,32.08 7.00,32.56 7.31,32.85
             8.19,33.63 9.59,34.31 10.74,34.56
             10.74,34.56 11.98,34.70 11.98,34.70
             12.32,34.73 12.57,34.82 12.93,34.81
             12.93,34.81 13.70,34.68 13.70,34.68
             13.70,34.68 14.53,34.68 14.53,34.68
             14.67,34.67 14.72,34.69 14.88,34.68
             15.89,34.61 17.52,34.36 18.49,34.09
             19.34,33.86 20.58,33.37 21.39,33.00
             21.39,33.00 22.81,32.36 22.81,32.36
             22.81,32.36 23.87,31.76 23.87,31.76
             25.22,30.97 25.95,30.49 27.18,29.53
             28.96,28.15 30.18,27.00 31.57,25.23
             32.58,23.95 33.81,22.10 34.34,20.56
             34.34,20.56 34.63,19.38 34.63,19.38
             34.79,18.69 34.92,18.19 34.93,17.48
             34.93,17.48 35.05,15.89 35.05,15.89
             35.05,15.89 35.05,15.17 35.05,15.17
             35.05,14.60 34.98,14.41 34.81,13.88
             34.81,13.88 34.61,13.23 34.61,13.23
             34.14,12.06 33.25,11.25 32.21,10.60
             31.63,10.24 30.77,9.81 30.08,9.79
             30.26,10.18 30.78,10.56 31.10,11.03
             31.63,11.82 31.75,12.72 31.73,13.64
             31.73,14.56 31.43,15.46 31.09,16.30
             30.43,17.90 29.63,19.10 28.56,20.44
             25.83,23.84 21.72,26.74 17.72,28.45
             16.33,29.05 14.50,29.63 12.99,29.82
             12.99,29.82 11.93,29.91 11.93,29.91
             11.93,29.91 11.21,29.96 11.21,29.96
             11.21,29.96 10.69,29.90 10.69,29.90
             10.69,29.90 10.21,29.90 10.21,29.90
             9.21,29.75 8.07,29.46 7.25,28.84
             6.82,28.51 6.45,28.10 6.07,27.71
             5.84,27.48 5.73,27.30 5.42,27.18 Z
           M 35.64,19.79
           C 35.64,19.79 35.52,19.79 35.52,19.79
             35.52,19.79 34.91,21.21 34.91,21.21
             34.47,22.18 33.98,23.17 33.36,24.05
             33.36,24.05 31.48,26.53 31.48,26.53
             31.48,26.53 30.91,27.12 30.91,27.12
             28.79,29.41 26.60,31.10 23.87,32.61
             23.87,32.61 22.10,33.55 22.10,33.55
             22.10,33.55 20.08,34.34 20.08,34.34
             18.55,34.90 18.07,35.01 16.48,35.31
             16.48,35.31 15.35,35.51 15.35,35.51
             15.35,35.51 14.23,35.58 14.23,35.58
             14.23,35.58 13.52,35.64 13.52,35.64
             13.52,35.64 12.99,35.58 12.99,35.58
             12.99,35.58 12.40,35.58 12.40,35.58
             12.40,35.58 11.39,35.45 11.39,35.45
             10.86,35.38 10.67,35.29 10.09,35.28
             10.32,35.74 11.11,36.14 11.57,36.36
             12.47,36.79 13.03,36.89 13.99,37.02
             14.57,37.09 14.48,37.12 15.12,37.12
             15.12,37.12 16.66,37.00 16.66,37.00
             19.15,36.99 21.78,36.11 23.99,35.00
             23.99,35.00 26.53,33.59 26.53,33.59
             27.20,33.18 27.81,32.69 28.43,32.19
             30.47,30.56 31.95,29.15 33.40,26.94
             34.01,26.00 34.73,24.88 35.09,23.81
             35.09,23.81 35.43,22.33 35.43,22.33
             35.53,21.85 35.64,21.60 35.64,21.09
             35.64,21.09 35.64,19.79 35.64,19.79 Z"
      />
      <path
        id="Météo Médiocre"
        className="fill-white"
        stroke="currentColor"
        strokeWidth="0"
        d="M 55.53,18.82
           C 55.53,18.82 55.53,9.09 55.53,9.09
             55.53,9.09 52.31,15.43 52.31,15.43
             52.31,15.43 50.10,15.43 50.10,15.43
             50.10,15.43 46.93,9.09 46.93,9.09
             46.93,9.09 46.93,18.82 46.93,18.82
             46.93,18.82 43.65,18.82 43.65,18.82
             43.65,18.82 43.65,2.10 43.65,2.10
             43.65,2.10 46.88,2.10 46.88,2.10
             46.88,2.10 51.23,11.13 51.23,11.13
             51.23,11.13 55.53,2.10 55.53,2.10
             55.53,2.10 58.76,2.10 58.76,2.10
             58.76,2.10 58.76,18.82 58.76,18.82
             58.76,18.82 55.53,18.82 55.53,18.82M 63.28,13.66
           C 63.28,15.22 64.24,16.40 65.96,16.40
             67.31,16.40 67.95,16.02 68.71,15.27
             68.71,15.27 70.53,17.10 70.53,17.10
             69.30,18.33 68.11,19.03 65.91,19.03
             63.01,19.03 60.26,17.74 60.26,12.80
             60.26,8.82 62.42,6.56 65.59,6.56
             68.97,6.56 70.91,9.03 70.91,12.42
             70.91,12.42 70.91,13.76 70.91,13.76
             70.91,13.76 63.28,13.76 63.28,13.76M 67.63,10.27
           C 67.31,9.52 66.61,8.98 65.59,8.98
             64.57,8.98 63.87,9.52 63.54,10.27
             63.38,10.70 63.28,11.02 63.28,11.56
             63.28,11.56 67.90,11.56 67.90,11.56
             67.90,11.02 67.85,10.70 67.63,10.27 Z
           M 76.61,18.82
           C 74.14,18.82 73.06,17.04 73.06,15.32
             73.06,15.32 73.06,9.25 73.06,9.25
             73.06,9.25 71.77,9.25 71.77,9.25
             71.77,9.25 71.77,6.94 71.77,6.94
             71.77,6.94 73.06,6.94 73.06,6.94
             73.06,6.94 73.06,3.33 73.06,3.33
             73.06,3.33 76.12,3.33 76.12,3.33
             76.12,3.33 76.12,6.94 76.12,6.94
             76.12,6.94 78.27,6.94 78.27,6.94
             78.27,6.94 78.27,9.25 78.27,9.25
             78.27,9.25 76.12,9.25 76.12,9.25
             76.12,9.25 76.12,15.11 76.12,15.11
             76.12,15.81 76.45,16.18 77.20,16.18
             77.20,16.18 78.27,16.18 78.27,16.18
             78.27,16.18 78.27,18.82 78.27,18.82
             78.27,18.82 76.61,18.82 76.61,18.82M 82.31,13.66
           C 82.31,15.22 83.27,16.40 84.99,16.40
             86.34,16.40 86.98,16.02 87.74,15.27
             87.74,15.27 89.56,17.10 89.56,17.10
             88.33,18.33 87.14,19.03 84.94,19.03
             82.04,19.03 79.30,17.74 79.30,12.80
             79.30,8.82 81.45,6.56 84.62,6.56
             88.01,6.56 89.94,9.03 89.94,12.42
             89.94,12.42 89.94,13.76 89.94,13.76
             89.94,13.76 82.31,13.76 82.31,13.76M 86.66,10.27
           C 86.34,9.52 85.64,8.98 84.62,8.98
             83.60,8.98 82.90,9.52 82.58,10.27
             82.41,10.70 82.31,11.02 82.31,11.56
             82.31,11.56 86.93,11.56 86.93,11.56
             86.93,11.02 86.82,10.70 86.66,10.27 Z
           M 66.39,4.62
           C 66.39,4.62 64.35,4.62 64.35,4.62
             64.35,4.62 66.34,1.88 66.34,1.88
             66.34,1.88 69.03,1.88 69.03,1.88
             69.03,1.88 66.39,4.62 66.39,4.62M 100.26,17.47
           C 99.51,18.28 98.27,18.98 96.45,18.98
             94.62,18.98 93.43,18.28 92.68,17.47
             91.61,16.34 91.28,14.95 91.28,12.69
             91.28,10.48 91.55,9.09 92.68,7.96
             93.43,7.15 94.67,6.45 96.45,6.45
             98.27,6.45 99.51,7.15 100.26,7.96
             101.34,9.09 101.66,10.48 101.66,12.69
             101.61,14.89 101.34,16.29 100.26,17.47M 97.90,9.73
           C 97.52,9.35 97.09,9.19 96.45,9.19
             95.85,9.19 95.37,9.35 95.05,9.73
             94.40,10.38 94.35,11.40 94.35,12.69
             94.35,13.98 94.40,15.05 95.05,15.65
             95.42,16.02 95.85,16.18 96.45,16.18
             97.04,16.18 97.52,16.02 97.90,15.65
             98.54,15.00 98.60,13.92 98.60,12.69
             98.60,11.40 98.49,10.38 97.90,9.73 Z
           M 85.42,4.62
           C 85.42,4.62 83.38,4.62 83.38,4.62
             83.38,4.62 85.37,1.88 85.37,1.88
             85.37,1.88 88.06,1.88 88.06,1.88
             88.06,1.88 85.42,4.62 85.42,4.62M 55.53,37.85
           C 55.53,37.85 55.53,28.12 55.53,28.12
             55.53,28.12 52.31,34.46 52.31,34.46
             52.31,34.46 50.10,34.46 50.10,34.46
             50.10,34.46 46.93,28.12 46.93,28.12
             46.93,28.12 46.93,37.85 46.93,37.85
             46.93,37.85 43.65,37.85 43.65,37.85
             43.65,37.85 43.65,21.18 43.65,21.18
             43.65,21.18 46.88,21.18 46.88,21.18
             46.88,21.18 51.23,30.22 51.23,30.22
             51.23,30.22 55.53,21.18 55.53,21.18
             55.53,21.18 58.76,21.18 58.76,21.18
             58.76,21.18 58.76,37.85 58.76,37.85
             58.76,37.85 55.53,37.85 55.53,37.85M 63.28,32.69
           C 63.28,34.25 64.24,35.43 65.96,35.43
             67.31,35.43 67.95,35.05 68.71,34.30
             68.71,34.30 70.53,36.13 70.53,36.13
             69.30,37.37 68.11,38.06 65.91,38.06
             63.01,38.06 60.26,36.77 60.26,31.83
             60.26,27.85 62.42,25.59 65.59,25.59
             68.97,25.59 70.91,28.06 70.91,31.45
             70.91,31.45 70.91,32.80 70.91,32.80
             70.91,32.80 63.28,32.80 63.28,32.80M 67.63,29.30
           C 67.31,28.55 66.61,28.01 65.59,28.01
             64.57,28.01 63.87,28.55 63.54,29.30
             63.38,29.73 63.28,30.05 63.28,30.59
             63.28,30.59 67.90,30.59 67.90,30.59
             67.90,30.11 67.85,29.78 67.63,29.30 Z
           M 66.39,23.71
           C 66.39,23.71 64.35,23.71 64.35,23.71
             64.35,23.71 66.34,20.91 66.34,20.91
             66.34,20.91 69.03,20.91 69.03,20.91
             69.03,20.91 66.39,23.71 66.39,23.71 Z
           M 79.51,37.85
           C 79.51,37.85 79.51,36.72 79.51,36.72
             78.65,37.63 77.79,38.01 76.50,38.01
             75.32,38.01 74.19,37.58 73.49,36.94
             72.25,35.70 72.25,33.60 72.25,31.77
             72.25,29.95 72.25,27.85 73.49,26.67
             74.19,25.97 75.26,25.59 76.45,25.59
             77.68,25.59 78.65,25.91 79.40,26.83
             79.40,26.83 79.40,21.18 79.40,21.18
             79.40,21.18 82.47,21.18 82.47,21.18
             82.47,21.18 82.47,37.85 82.47,37.85
             82.47,37.85 79.51,37.85 79.51,37.85M 77.36,28.28
           C 75.53,28.28 75.32,29.78 75.32,31.77
             75.32,33.76 75.53,35.27 77.36,35.27
             79.19,35.27 79.46,33.76 79.46,31.77
             79.46,29.78 79.19,28.28 77.36,28.28 Z
           M 87.90,23.55
           C 87.90,23.55 84.78,23.55 84.78,23.55
             84.78,23.55 84.78,21.08 84.78,21.08
             84.78,21.08 87.90,21.08 87.90,21.08
             87.90,21.08 87.90,23.55 87.90,23.55 Z
           M 87.90,37.85
           C 87.90,37.85 84.83,37.85 84.83,37.85
             84.83,37.85 84.83,25.65 84.83,25.65
             84.83,25.65 87.90,25.65 87.90,25.65
             87.90,25.65 87.90,37.85 87.90,37.85 Z
           M 99.26,36.47
           C 98.51,37.28 97.27,37.98 95.45,37.98
             93.62,37.98 92.43,37.28 91.68,36.47
             90.61,35.34 90.28,33.95 90.28,31.69
             90.28,29.48 90.55,28.09 91.68,26.96
             92.43,26.15 93.67,25.45 95.45,25.45
             97.27,25.45 98.51,26.15 99.26,26.96
             100.34,28.09 100.66,29.48 100.66,31.69
             100.61,33.89 100.34,35.29 99.26,36.47M 96.90,28.73
           C 96.52,28.35 96.09,28.19 95.45,28.19
             94.85,28.19 94.37,28.35 94.05,28.73
             93.40,29.38 93.35,30.40 93.35,31.69
             93.35,32.98 93.40,34.05 94.05,34.65
             94.42,35.02 94.85,35.18 95.45,35.18
             96.04,35.18 96.52,35.02 96.90,34.65
             97.54,34.00 97.60,32.92 97.60,31.69
             97.60,30.40 97.49,29.38 96.90,28.73 Z
           M 117.45,27.94
           C 117.73,26.45 119.02,25.61 120.49,25.88
             120.87,25.95 121.69,26.16 121.84,26.57
             121.94,26.84 121.65,27.32 121.54,27.57
             121.54,27.57 120.49,29.97 120.49,29.97
             120.03,29.76 119.65,29.33 119.11,29.37
             118.22,29.43 117.74,30.50 117.58,31.26
             117.40,32.16 117.45,33.02 117.45,33.93
             117.45,33.93 117.45,37.71 117.45,37.71
             117.45,37.71 113.58,37.71 113.58,37.71
             113.58,37.71 113.58,26.28 113.58,26.28
             113.58,26.28 117.26,26.28 117.26,26.28
             117.26,26.90 117.18,27.38 117.45,27.94 Z
           M 112.45,34.56
           C 112.13,35.48 111.68,36.38 110.90,36.99
             109.23,38.27 105.61,38.32 103.95,36.99
             102.77,36.04 102.15,34.23 102.13,32.74
             102.10,30.72 102.18,28.43 103.86,27.01
             104.27,26.67 104.92,26.30 105.42,26.14
             106.84,25.67 109.36,25.74 110.62,26.60
             111.53,27.21 112.11,28.21 112.36,29.27
             112.36,29.27 109.16,30.55 109.16,30.55
             109.02,29.18 107.62,28.11 106.53,29.36
             106.30,29.62 106.19,29.86 106.09,30.18
             105.76,31.20 105.75,33.37 106.33,34.29
             106.80,35.03 107.72,35.26 108.43,34.71
             108.89,34.35 109.07,33.91 109.25,33.38
             109.89,33.48 111.85,34.25 112.45,34.56 Z
           M 125.28,32.66
           C 125.28,34.22 126.24,35.40 127.96,35.40
             129.31,35.40 129.95,35.02 130.71,34.27
             130.71,34.27 132.53,36.10 132.53,36.10
             131.30,37.33 130.11,38.03 127.91,38.03
             125.01,38.03 122.26,36.74 122.26,31.80
             122.26,27.82 124.42,25.56 127.59,25.56
             130.97,25.56 132.91,28.03 132.91,31.42
             132.91,31.42 132.91,32.76 132.91,32.76
             132.91,32.76 125.28,32.76 125.28,32.76M 129.63,29.27
           C 129.31,28.52 128.61,27.98 127.59,27.98
             126.57,27.98 125.87,28.52 125.54,29.27
             125.38,29.70 125.28,30.02 125.28,30.56
             125.28,30.56 129.90,30.56 129.90,30.56
             129.90,30.02 129.85,29.70 129.63,29.27 Z"
      />
    </svg>
  </div>
);

export default MenuLogo;
